module.exports = __webpack_public_path__ + "img/measure-icon-sure.4d354633.png";